import { WorkScheduleModel } from '@/types';
import { BaseService } from '@/services';

class WorkScheduleService extends BaseService<WorkScheduleModel> {}

export default new WorkScheduleService('work-schedules');
